import { useOkapiKy } from "@folio/stripes/core";
import { fetchPublisherById } from "../api/publisherService";
import { useDetailEntity } from "./useDetailEntity";
export var usePublisherActions = function () {
    var ky = useOkapiKy();
    var _a = useDetailEntity("publisher-detail", function (id) {
        return fetchPublisherById(ky, id);
    }), selectedItem = _a.selectedItem, handleRowClick = _a.handleRowClick, handleCloseDetail = _a.handleCloseDetail;
    return {
        selectedPublisher: selectedItem,
        handleRowClick: function (item) { return handleRowClick(item.id); },
        handleCloseDetail: handleCloseDetail,
    };
};
